<div class="outbound-numbers-list__header">
  <button
    type="button"
    class="btn btn-sm btn-primary outbound-numbers-list__add"
    (click)="openAdd()">
    <i class="pi pi-plus" aria-hidden="true"></i>
    <span>{{ 'Settings::PhoneNumbers:AddOutboundNumber' | abpLocalization }}</span>
  </button>
</div>

<div class="card outbound-numbers-list__card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="items"
      [totalRecords]="totalRecords"
      [loading]="loading"
      [first]="skipCount"
      [rows]="rows"
      (lazyLoad)="onLazyLoad($event)" />
  </div>
</div>

<ng-template #defaultTpl let-row>
  <button
    type="button"
    class="outbound-numbers-list__star"
    [class.outbound-numbers-list__star--active]="row.isDefault"
    [disabled]="row.isDefault"
    [pTooltip]="'Settings::PhoneNumbers:SetAsDefault' | abpLocalization"
    tooltipPosition="top"
    (click)="setDefault(row); $event.stopPropagation()">
    <i class="pi" [ngClass]="row.isDefault ? 'pi-star-fill' : 'pi-star'" aria-hidden="true"></i>
  </button>
</ng-template>

<ng-template #numberTpl let-row>
  <span class="outbound-numbers-list__primary">{{ row.phoneNumber }}</span>
</ng-template>

<ng-template #gatewayTpl let-row>
  @if (row.gatewayUsername || row.gatewayRealm) {
    <div class="outbound-numbers-list__stack">
      <span class="outbound-numbers-list__primary">{{ row.gatewayUsername || '—' }}</span>
      @if (row.gatewayRealm) {
        <span class="outbound-numbers-list__muted">{{ row.gatewayRealm }}</span>
      }
    </div>
  } @else {
    <span class="outbound-numbers-list__muted">—</span>
  }
</ng-template>

<ng-template #protocolTpl let-row>
  @if (row.gatewayRegister) {
    <div class="outbound-numbers-list__stack">
      <span class="outbound-numbers-list__primary">{{ getProtocolLabel(row.protocol) }}</span>
      <span class="outbound-numbers-list__muted">
        {{ 'Settings::PhoneNumbers:RegisterYes' | abpLocalization }}
      </span>
    </div>
  } @else {
    <span class="outbound-numbers-list__muted">
      {{ 'Settings::PhoneNumbers:NoRegistration' | abpLocalization }}
    </span>
  }
</ng-template>

<ng-template #statusTpl let-row>
  <p-tag
    [value]="
      isActive(row)
        ? ('Settings::PhoneNumbers:Active' | abpLocalization)
        : ('Settings::PhoneNumbers:Inactive' | abpLocalization)
    "
    [severity]="isActive(row) ? 'success' : 'secondary'">
  </p-tag>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>

<app-outbound-number-form
  *ngIf="showForm"
  [visible]="true"
  [isEdit]="isEditMode"
  [model]="selectedItem"
  (visibleChange)="onFormVisibilityChange($event)"
  (saved)="onFormSaved($event)" />
